// extracted by mini-css-extract-plugin
export default {"menu_mobile":"menuMobile_menu_mobile__EDbao","fadin_in":"menuMobile_fadin_in__Pw31r"};